import React from 'react';
import PrimaryHeading from "../../components/PrimaryHeading/PrimaryHeading";
import HeadingGradient from "../../components/HeadingGradient/HeadingGradient";
import Tile from "../../components/Tile/Tile";
import ProgressBubbles from "../../components/ProgressBubbles/ProgressBubbles";

function SectionDecision({ sequence }) {
    return (
        <div className="details-chart">
            <PrimaryHeading>
                <HeadingGradient>The decision sequence</HeadingGradient>
                <span>what consumers decide first,<br/> second, third, and fourth</span>
            </PrimaryHeading>
            <Tile>
                <ProgressBubbles
                    data={sequence}
                />
            </Tile>
        </div>
    );
}

export default SectionDecision;